import { render, staticRenderFns } from "./AfterSalesService.vue?vue&type=template&id=713799bb&scoped=true"
import script from "./AfterSalesService.vue?vue&type=script&lang=js"
export * from "./AfterSalesService.vue?vue&type=script&lang=js"
import style0 from "./AfterSalesService.vue?vue&type=style&index=0&id=713799bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713799bb",
  null
  
)

export default component.exports